import styles from './VerifiedLeadBox.module.css';

const ATTRS = [
  'Deliverability-checked email',
  'Employment confirmed',
  'Company vetted against your ICP',
  'Direct dial where available',
  'AI-written fit rationale',
];

export default function VerifiedLeadBox() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.box}>
          <h2 className={styles.heading}>What's a verified lead?</h2>

          <ul className={styles.attrs}>
            {ATTRS.map((a) => (
              <li key={a} className={styles.attr}>
                <span className={styles.check} aria-hidden="true">✓</span>
                {a}
              </li>
            ))}
          </ul>

          <p className={styles.quote}>
            Other tools sell you raw credits and let you find out the email bounces. We only
            count it when it's real.
          </p>
        </div>
      </div>
    </section>
  );
}
